<template>
  <div class="DeviceInfo">
    <div class="ptmember-cbj">
      <div class="ptmember-center">
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true>
          <div class="root">
              <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="手机号" prop="tel">
                  <el-input placeholder="请输入手机号" v-model.number="form.tel"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="验证码" class="code">
                    <el-input v-model="form.sendcode" placeholder="请输入验证码"></el-input>
                    <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false">发送验证码</el-button>
                    <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}</el-button>
                </el-form-item>
                <el-form-item label="设置密码" prop="pass">
                  <el-input type="password"  placeholder="请设置密码" v-model="form.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码"  prop="checkPass">
                  <el-input type="password" placeholder="请确认密码" v-model="form.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit(form)" size="medium">确定</el-button>
                  <p class="pt-bottom">
                    <router-link  :to="{path:'Login'}" ><span>已有账号，</span>立即登录</router-link>
                  </p>
                </el-form-item>
              </el-form>
            </div>
         </el-tabs>
       </div>
     </div>
   </div>
</template>
<style scoped >
    .DeviceInfo >>> .el-tabs__item {font-size: 14px;}
    .DeviceInfo >>> .el-tabs__active-bar{width: 0 !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;;}
    .DeviceInfo >>> .el-tabs__nav-scroll{width: 84%;float: right;}
    .DeviceInfo >>> .el-button--medium{width: 100%;background: #2c5fab;border-color: #2c5fab;}

    .DeviceInfo >>> .root {width:100vw;display: table-cell;vertical-align: middle;}
    .DeviceInfo >>> .root  form {width: 100%;margin: auto;}
    .DeviceInfo >>> .root  form .code .el-input{width: 66%;border-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-button {background: #f5f7fa;width: 34%;border-top-left-radius: 0px;border-bottom-left-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-input .el-input__inner{border-top-right-radius: 0px;border-bottom-right-radius: 0px;}
</style>
<script>
export default{
  data(){
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.form.checkPass !== '') {
            this.$refs.form.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      activeName: 'second',
      name: "Register",
      form: {
          tel: '',
          pass:'',
          checkPass:'',
          name:'',
          dwzw:'',
          sendcode: '',
      },
      rules: {
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
        ],
        pass: [
          {  required: true,validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          {  required: true,validator: validatePass2, trigger: 'blur'}
        ],
      },

      Register: {
          tel: '',
          sendcode: '',
          pass:'',
          checkPass:'',
      },
      disabled: false,
      time: 0,
      btntxt: "重新发送",
    }
  },
  mounted () {
    var that = this;
    that.$api.post("/Upload/uploadcorda",{}).then(res => {
      console.log(res);
    });
  },
  methods:{
    // 选项卡切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 登录提交
    onSubmit(form) {
      console.log(form);

      if(form.checkPass !== form.pass ){
         this.$message.error('俩次密码输入不一样');
         return
      }
      if(form.checkPass =='' ||  form.pass=='' ){
        this.$message.error('请输入密码');
        return
      }
      var that = this;
      var yzms =  this.$cookieStore.getCookie('yzms');  // 获取返回来的验证码
      if(form.sendcode==''){
        this.$message.error('验证码不能为空');
        return
      }
      if(form.yzms==''){
        this.$message.error('验证码已过期');
        return
      }
      if(form.sendcode===yzms){
        console.log(yzms);
        that.$api.post("/Login/forgetpass",{'tel':form.tel,'password':form.checkPass}).then(res => {
            console.log(res);
            if(res.code==1){
              that.show = false;
              this.$cookieStore.setCookie( 'userid' ,res.userid, 360000);
              this.$cookieStore.delCookie('yzms');
              this.$message({
                message: res.msg,
                type: 'success'
              });
              setTimeout(this.$router.push('/Login'), 1000);
            }
        })
      }else{
        this.$message.error('请输入正确验证码');
      }
    },


    //手机验证发送验证码
    sendcode() {
      var that = this;
        const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if (this.form.tel == '') {
           this.$message.error('手机号不能为空');
           return
        }
        if (!reg.test(this.form.tel)) {
              this.$message.error('请输入正确的手机号');
            return
        } else {

            that.$api.post("/upload/zhmmyzm",{'tel':this.form.tel}).then(res => {
                console.log(res);
                 if(res.code == 1){
                   this.$message({
                       message: '发送成功',
                       type: 'success',
                   });
                   this.time = 60;
                   this.disabled = true;
                   this.timer();
                 }else{
                   this.$message.error('发送失败');
                 }
                 this.$cookieStore.setCookie( 'yzms' ,res.msg, 61);
            })




        }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
          this.time--;
          this.btntxt = this.time + "s后重新获取";
          setTimeout(this.timer, 1000);
      }else{
          this.time = 0;
          this.btntxt = "获取验证码";
          this.disabled = false;
      }
    },
  },
 }
</script>



// WEBPACK FOOTER //
// src/components/login/forgetpass.vue